const initialState = () => ({
  master_settings: {
    agentMode: false,
    defaultCompany: {},
  },
  masters: [],
})

export default initialState
